import {
  ArcElement,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  Tooltip,
} from "chart.js";
import { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import "../../CSS/ComponentCSS/DoughutCharts.css";
import { randomColor, randomColorValue } from "./ColorList";

ChartJS.register(ArcElement, Tooltip, Legend);

type DoughnutChartsProps = {
  columnlabel: any[];
  data: any[];
  label: any;
};

export default function DoughnutCharts(props: DoughnutChartsProps) {
  const [data, setData] = useState<any>({ label: [], datasets: [] });
  const color = randomColorValue();
  const [randomColors, setRandomColors] = useState<any[]>([]);

  useEffect(() => {
    if (randomColors.length == 0 && props.data.length > 0) {
      setRandomColors(props.data.map(() => randomColor(color)));
    }

    if (props.columnlabel.length != 0 && randomColors.length > 0) {
      setData({
        labels: props.columnlabel,
        datasets: [
          {
            label: props.label,
            data: props.data,
            backgroundColor: randomColors,
            borderWidth: 1,
          },
        ],
      });
    }
  }, [props.data, randomColors]);

  const options: ChartOptions<"doughnut"> = {
    responsive: true,
    cutout: "50%", // 도넛 차트 굵기 조절
    plugins: {
      datalabels: {
        formatter: function (value, context) {
          return value + "%";
        },
        color: "black",
      },
      legend: {
        display: true,
        labels: {
          usePointStyle: true,
          padding: 10,
        },
      },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            let label = context.dataset.label + "" || "";
            return label + ": " + context.parsed + "%";
          },
        },
      },
    },
    aspectRatio: 1.3,
  };

  return (
    <div className="DoughnutChartContainer">
      <Doughnut data={data} options={options} />
    </div>
  );
}
